import React from "react";
import { useNavigate } from "react-router-dom";

const ParentManagementSystem = () => {
  const navigate = useNavigate();

  return (
    <section className="menu-section-bg">
      <div className="menu-container">

        {/* ===== HEADER ===== */}
        <div className="product-subtitleBg-header">
          <h1 className="product-titleBg">
            Parent Management System (PMS)
          </h1>
          <p className="product-subtitleBg">
            Bridge the gap between home and school with real-time communication,
            fee tracking, student progress updates, and interactive parent portals.
          </p>
        </div>

        {/* ===== SECTION 1 ===== */}
        <div className="product-and-sol-mainCard ps-two-column-grid product-sol-card">
          <div className="enrollment-image-card product-sol-card-imageBox">
            <img
              src="../images/product&soluction/StudentInformationSystem1.jpg"
              alt="Parent Portal Overview"
              className="ps-main-image"
            />
          </div>

          <div>
            <h2 className="product-and-sol-sectionTitle">
              Smart Parent Engagement & Portal
            </h2>
            <p className="product-and-sol-section-text">
              Empower parents with complete visibility into their child's daily school
              life, academic performance, attendance records, and teacher announcements
              in one unified platform.
            </p>

            <ul className="product-and-sol-list">
              <li>✔ Real-time student progress & grade tracking</li>
              <li>✔ Instant attendance & leave alerts</li>
              <li>✔ Seamless parent-teacher messaging</li>
              <li>✔ Digital fee payment & receipt download</li>
            </ul>

            <div
              className="read-more-btn"
              onClick={() => window.open("https://mdisu.in/pms", "_blank")}
            >
              Visit PMS Portal →
            </div>
          </div>
        </div>

        {/* ===== SECTION 2 ===== */}
        <div className="product-and-sol-secondCard ps-two-column-grid product-sol-card">
          <div>
            <h2 className="product-and-sol-sectionTitle">
              Why Parent Management Software Is Essential
            </h2>
            <p className="product-and-sol-section-text">
              Strong parent-school collaboration directly drives student success. Our PMS
              eliminates phone calls and paper notes by giving parents 24/7 self-service
              access to important updates and school events.
            </p>

            <ul className="product-and-sol-list">
              <li>✔ Enhances parent satisfaction & trust</li>
              <li>✔ Reduces administrative query calls</li>
              <li>✔ Ensures transparent fee collection</li>
              <li>✔ Automates emergency & event notifications</li>
              <li>✔ Provides multi-child profile switching</li>
            </ul>

            <div
              className="read-more-btn"
              onClick={() => window.open("https://mdisu.in/pms", "_blank")}
            >
              Access PMS Portal →
            </div>
          </div>

          <div className="student-image-card product-sol-card-imageBox">
            <img
              src="../images/product&soluction/academicmanagement.jpg"
              alt="Parent Communication"
              className="ps-main-image"
            />
          </div>
        </div>

        {/* ===== FEATURES ===== */}
        <div className="ps-feature-grid">

          <FeatureCard
            typeClass="credentialing"
            backgroundColor="#e9fdf3"
            icon={icons.notification}
            title="Real-Time Alerts"
            description="Instant notifications for attendance, homework, exam schedules, and circulars."
          />

          <FeatureCard
            typeClass="wallet"
            backgroundColor="#f3ecff"
            icon={icons.payment}
            title="Fee Payment & History"
            description="Secure online tuition payments with instant digital receipt generation."
          />

          <FeatureCard
            typeClass="human-resources"
            backgroundColor="#f1f6ff"
            icon={icons.academics}
            title="Academic Progress"
            description="View report cards, exam grades, and teacher feedback anytime."
          />

          <FeatureCard
            typeClass="education"
            backgroundColor="#fff3cc"
            icon={icons.connect}
            title="Parent-Teacher Connect"
            description="Direct messaging and scheduled parent-teacher meeting requests."
          />

          <FeatureCard
            typeClass="marketing"
            backgroundColor="#ffe6dc"
            icon={icons.calendar}
            title="Event & Calendar Sync"
            description="Track school holidays, exam timetables, and sports events."
          />

          <FeatureCard
            typeClass="analytics"
            backgroundColor="#eaf9fa"
            icon={icons.transport}
            title="Transport & Safety"
            description="Live school bus tracking updates and emergency broadcast notifications."
          />

        </div>

        {/* ===== CTA ===== */}
        <div className="ps-highlight-wrapper">
          <div className="ps-highlight-card">

            <div className="ps-highlight-header">
              <h2 className="ps-highlight-title">
                Elevate Parent Engagement Today
              </h2>
              <p className="ps-highlight-subtitle">
                Foster stronger school-family partnerships
              </p>
            </div>

            <div className="ps-highlight-body">
              <p className="ps-highlight-text">
                Deliver a modern, transparent digital experience that parents love and trust.
              </p>

              <div className="ps-button-group">
                <a
                  href="https://mdisu.in/pms"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="Demo-button"
                  style={{ textDecoration: "none", display: "inline-block", textAlign: "center" }}
                >
                  Visit PMS Portal
                </a>
              </div>
            </div>

          </div>
        </div>

      </div>
    </section>
  );
};

/* ===== SHARED FEATURE CARD ===== */
const FeatureCard = ({
  icon,
  title,
  description,
  backgroundColor,
  typeClass
}) => (
  <div
    className={`card product-soluction-card ${typeClass}`}
    style={{ backgroundColor }}
  >
    <div className="card-overlay"></div>

    <div className="circle">
      <div className="ps-card-icon">{icon}</div>
    </div>

    <h3 className="ps-card-title">{title}</h3>
    <p className="product-soluction-card-text">{description}</p>
  </div>
);

/* ===== ICONS ===== */
const icons = {
  notification: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" stroke="#5a5cff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13.73 21a2 2 0 0 1-3.46 0" stroke="#5a5cff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  payment: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <rect x="2" y="5" width="20" height="14" rx="2" stroke="#ff8c00" strokeWidth="2" />
      <path d="M2 10h20" stroke="#ff8c00" strokeWidth="2" />
    </svg>
  ),
  academics: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <path d="M22 10v6M2 10l10-5 10 5-10 5z" stroke="#0ca85c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6 12v5c0 2 6 3 6 3s6-1 6-3v-5" stroke="#0ca85c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  connect: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="#e74c3c" strokeWidth="2" />
      <circle cx="9" cy="7" r="4" stroke="#e74c3c" strokeWidth="2" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" stroke="#e74c3c" strokeWidth="2" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" stroke="#e74c3c" strokeWidth="2" />
    </svg>
  ),
  calendar: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <rect x="3" y="4" width="18" height="18" rx="2" stroke="#6c5ce7" strokeWidth="2" />
      <path d="M16 2v4M8 2v4M3 10h18" stroke="#6c5ce7" strokeWidth="2" />
    </svg>
  ),
  transport: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-1.1 0-2 .9-2 2v7c0 .6.4 1 1 1h2" stroke="#0097e6" strokeWidth="2" />
      <circle cx="7.5" cy="17.5" r="2.5" stroke="#0097e6" strokeWidth="2" />
      <circle cx="16.5" cy="17.5" r="2.5" stroke="#0097e6" strokeWidth="2" />
    </svg>
  ),
};

export default ParentManagementSystem;
